module.exports = require("env-var");